import { WASTE_REPORTING_METHOD, WASTE_TYPE } from 'domain/shared/waste';
import { asciiTextValidation } from 'framework/form';

export const wasteRejectValidation = {
  reason: { type: 'string', required: true },
};

export const wasteValidation = {
  reason: {
    type: 'string',
    required: true,
    maxSize: 1024,
    ...asciiTextValidation,
  },
  type: {
    required: true,
    type: 'string',
  },
  otherWasteDetails: {
    type: 'object',
    properties: {
      issueDate: {
        type: 'date',
        required: {
          value: true,
          when: {
            $type: {
              eq: WASTE_TYPE.OTHER_EXPENSES_WASTE,
            },
          },
        },
        maxDate: {
          value: '$NOW',
          message: 'Cannot be in future',
        },
        minDate: {
          message: 'Dates are available within 2-week period',
        },
      },
      cost: {
        type: 'object',
        _divisible: false,
        properties: {
          amount: {
            type: 'string',
            required: {
              value: true,
              when: {
                $type: {
                  eq: WASTE_TYPE.OTHER_EXPENSES_WASTE,
                },
              },
            },
          },
          currency: {
            type: 'string',
            required: {
              value: true,
              when: {
                $type: {
                  eq: WASTE_TYPE.OTHER_EXPENSES_WASTE,
                },
              },
            },
          },
        },
      },
    },
  },
  laborWasteDetails: {
    type: 'object',
    properties: {
      reportingMethod: {
        type: 'string',
        required: {
          value: true,
          when: {
            $type: {
              eq: WASTE_TYPE.LABOR_COST_WASTE,
            },
          },
        },
      },
      employeeAlias: {
        type: 'string',
        required: {
          value: true,
          when: {
            $type: {
              eq: WASTE_TYPE.LABOR_COST_WASTE,
            },
            '$laborWasteDetails.reportingMethod': {
              ne: WASTE_REPORTING_METHOD.BY_TICKET_IDS,
            },
          },
        },
      },
      ticketsIds: {
        type: 'array',
        required: {
          value: true,
          when: {
            $type: {
              eq: WASTE_TYPE.LABOR_COST_WASTE,
            },
            '$laborWasteDetails.reportingMethod': {
              ne: WASTE_REPORTING_METHOD.BY_PROJECT_PERIOD,
            },
          },
        },
      },
      period: {
        type: 'object',
        _divisible: true,
        properties: {
          startDate: {
            type: 'date',
            required: {
              value: true,
              when: {
                '$laborWasteDetails.reportingMethod': {
                  eq: WASTE_REPORTING_METHOD.BY_PROJECT_PERIOD,
                },
              },
            },
            maxDate: {
              value: '$laborWasteDetails.period.endDate',
              message: "Start date can't be later than end date",
            },
            minDate: {
              message: 'Dates are available within 2-week period',
            },
          },
          endDate: {
            type: 'date',
            required: {
              value: true,
              when: {
                '$laborWasteDetails.reportingMethod': {
                  eq: WASTE_REPORTING_METHOD.BY_PROJECT_PERIOD,
                },
              },
            },
            minDate: {
              value: '$laborWasteDetails.period.startDate',
              message: "End date can't be earlier than start date",
            },
            maxDate: {
              value: '$NOW',
              message: 'Cannot be in future',
            },
          },
        },
      },
    },
  },
};
